








































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CPopUp from "../CPopUp.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

const monthLst = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

@Component({
    name: 'c-prg-tree-table',
    components: { 'c-pop-up': CPopUp },
    // mixins: [ AlterationI18nMixin ],
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    }
})

export default class CPrgTreeTable extends AlterationI18nMixin {
    private range(n: number) {
        return [...Array(n).keys()];
    }
    private monthLst: any[] = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

    @Prop({
        required: true,
        default: []
    })
    private tableData!: any[];

    private treeData: any[] = [];
    private uSumVisible: any = 2;
    private totalData = {
        january: 0,
        february: 0,
        march: 0,
        april: 0,
        may: 0,
        june: 0,
        july: 0,
        august: 0,
        september: 0,
        october: 0,
        november: 0,
        december: 0
    }

    private totalTree() {
        const totalData: any = {
            january: 0,
            february: 0,
            march: 0,
            april: 0,
            may: 0,
            june: 0,
            july: 0,
            august: 0,
            september: 0,
            october: 0,
            november: 0,
            december: 0
        }
        for (const treEl of this.treeData) {
            for (let i = 0; i < 12; i++) {
                totalData[monthLst[i]] += treEl[monthLst[i]]
            }
        }
        this.totalData = totalData
    }

    private collapseAll:boolean = true;
    private clkCollapse(prgIndx: number | null, subIndx: number | null, spfIndx: number | null, collapse?: boolean) {
        if (prgIndx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.treeData) {
                el.collapse = this.collapseAll;
                for (const subEl of el.vals) {
                    subEl.collapse = this.collapseAll;
                    for (const spfEl of subEl.vals) {
                        if (spfEl.collapse!==undefined) { spfEl.collapse = this.collapseAll; }
                    }
                }
            }
            return;
        }

        if (collapse ===undefined) { return; }


        if (subIndx === null) {
            this.treeData[prgIndx].collapse = collapse;
            if (!collapse && this.collapseAll) { this.collapseAll = false; }
            if (collapse !== this.collapseAll) {
                let fl = false;
                for (let i =0; i < this.treeData.length; i++) {
                    if (this.treeData[i].collapse !== collapse) {
                        fl = true;
                        break;
                    }
                }
                if (!fl) { this.collapseAll = collapse; }
            }
            for (const subEl of this.treeData[prgIndx].vals) {
                subEl.collapse = collapse;
                for (const spfEl of subEl.vals) {
                    if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                }
            }
        } else {
            if (spfIndx === null) {
                this.treeData[prgIndx].vals[subIndx].collapse = collapse;
                for (const spfEl of this.treeData[prgIndx].vals[subIndx].vals) {
                    if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                }
            } else {
                if (this.treeData[prgIndx].vals[subIndx].vals[spfIndx].collapse!==undefined) { this.treeData[prgIndx].vals[subIndx].vals[spfIndx].collapse = collapse; }
            }
        }
    }
    private mounted() {
        this.getTreeData();
        this.$watch('tableData', () => {
            this.getTreeData();
        });
        this.$watch('locale', () => { this.getTreeData(); }, { deep: true });
    }
    private sortNodes(nodes: any[], codeName: any) {
        return nodes.sort((a, b) => {
            if (a[codeName] < b[codeName]) return -1;
            if (a[codeName] > b[codeName]) return 1;
            return 0;
        });
    };
    private treeCodes: any[] = ['prg', 'ppr', 'spf']
    private sortTree(tree: any, depth: number = 0) {
        if (tree.vals) {
            tree.vals = this.sortNodes(tree.vals, this.treeCodes[depth]);
            for (const childNode of tree.vals) {
                this.sortTree(childNode, depth + 1);
            }
        }
    };
    private getTreeData() {
        if (!this.tableData) {
            this.treeData = [];
            return;
        }
        const tableData = this.tableData.slice();
        const prgMap: any = {}
        let _indexArrC = 0;
        for (const item of tableData) {
            item._indxArr = _indexArrC

            const prg = item.prg
            const ppr = item.ppr
            const spf = item.spf
            const plan = item.plan

            let prgNode: any = null;
            if (!(prg in prgMap)) {
                prgNode = Object.assign({collapse: this.collapseAll, vals: []}, item)
                this.incNameSet(prgNode, 'prg');
                prgMap[prg] = prgNode
            } else {
                prgNode = prgMap[prg]
                prgNode.plan += plan
                for (let i = 0; i < 12; i++) {
                    prgNode[monthLst[i]] += item[monthLst[i]]
                }
            }
            let pprNode: any = prgNode.vals.find((node: any) => node.ppr === ppr)
            this.incNameSet(prgNode.vals, 'ppr');
            if (!pprNode) {
                pprNode = Object.assign({collapse: this.collapseAll, vals: []}, item)
                prgNode.vals.push(pprNode)
            } else {
                pprNode.plan += plan
                for (let i = 0; i < 12; i++) {
                    pprNode[monthLst[i]] += item[monthLst[i]]
                }
            }
            let spfNode: any = pprNode.vals.find((node: any) => node.spf === spf)
            this.incNameSet(pprNode.vals, 'spf');
            if (!spfNode) {
                spfNode = Object.assign({}, item)
                pprNode.vals.push(spfNode)
            } else {
                spfNode.plan += plan
                for (let i = 0; i < 12; i++) {
                    spfNode[monthLst[i]] += item[monthLst[i]]
                }
            }

            _indexArrC++;
        }

        this.treeData = Object.values(prgMap)
        this.totalTree()
    }

    private totalSum(el: any) {
        let total = 0;
        for (let i = 0; i < 12; i++) {
            total += el[monthLst[i]];

        }
        return total
    }
}
